<template>
  <div>
    <!-- Header -->
    <div class="header py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="6" class="px-5">
              <h1 class="text-white">Ooops!</h1>
              <p class="text-lead text-white">Page not found.</p>

              <router-link to="/" class="font-weight-bold text-white mt-5">Back to dashboard</router-link>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">

      </div>
    </div>
    <!-- Page content -->
  
  </div>
</template>

<script>

export default {
  name: 'not-found'
};
</script>
